<!-- Button -->
<button
    mat-button
    class="text-default !bg-transparent"
    [matMenuTriggerFor]="userActions">
    <div class="flex flex-row justify-end items-center">
        <div class="mr-2 text-right">
            <div class="capitalize font-bold text-default">{{ user.name }}</div>
            <div class="mt-1 text-secondary text-xs">{{ user.role?.split('_').join(' ') | titlecase }}</div>
        </div>
        <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            width="400" height="400"
            [ngSrc]="appSettingService.getFilePath(user.avatar)">
        <mat-icon
            *ngIf="!showAvatar || !user.avatar"
            class="text-default"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    </span>
    </div>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <button mat-menu-item [routerLink]="['/profile/settings']">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <button mat-menu-item [matMenuTriggerFor]="themeMenu">
        <mat-icon [svgIcon]="'heroicons_outline:moon'"></mat-icon>
        <span>Theme</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="layoutMenu">
        <mat-icon [svgIcon]="'heroicons_outline:view-columns'"></mat-icon>
        <span>Layout</span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<mat-menu #themeMenu="matMenu">
    <button mat-menu-item (click)="setScheme('light')">
        <mat-icon [svgIcon]="'heroicons_outline:sun'" [ngClass]="{'text-primary': config?.scheme === 'light'}"></mat-icon>
        <span [ngClass]="{'text-primary font-medium': config?.scheme === 'light'}">Light</span>
    </button>
    <button mat-menu-item (click)="setScheme('dark')">
        <mat-icon [svgIcon]="'heroicons_outline:moon'" [ngClass]="{'text-primary': config?.scheme === 'dark'}"></mat-icon>
        <span [ngClass]="{'text-primary font-medium': config?.scheme === 'dark'}">Dark</span>
    </button>
    <button mat-menu-item (click)="setScheme('auto')">
        <mat-icon [svgIcon]="'heroicons_outline:computer-desktop'" [ngClass]="{'text-primary': config?.scheme === 'auto'}"></mat-icon>
        <span [ngClass]="{'text-primary font-medium': config?.scheme === 'auto'}">System</span>
    </button>
</mat-menu>

<mat-menu #layoutMenu="matMenu">
    <button mat-menu-item (click)="setLayout('classy')">
        <span [ngClass]="{'text-primary font-medium': config?.layout === 'classy'}">Classy</span>
    </button>
    <button mat-menu-item (click)="setLayout('dense')">
        <span [ngClass]="{'text-primary font-medium': config?.layout === 'dense'}">Dense</span>
    </button>
    <button mat-menu-item (click)="setLayout('compact')">
        <span [ngClass]="{'text-primary font-medium': config?.layout === 'compact'}">Compact</span>
    </button>
    <button mat-menu-item (click)="setLayout('thin')">
        <span [ngClass]="{'text-primary font-medium': config?.layout === 'thin'}">Thin</span>
    </button>
    <button mat-menu-item (click)="setLayout('modern')">
        <span [ngClass]="{'text-primary font-medium': config?.layout === 'modern'}">Modern</span>
    </button>
</mat-menu>

<mat-menu
    class="user-status-menu"
    #roles="matMenu">
    <button *ngFor="let role of rolesList"
            mat-menu-item
            (click)="updateUserRole(role)">
        <span [ngClass]="{'text-primary': role.roleid == user.activeRole?.roleid}">{{ role.rolename }}</span>
    </button>
</mat-menu>
